import React, { useState } from "react";
import "./updateclass.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import { classeType, requestType } from "../../../types/GlobalType";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../../_services/accountServices";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: classeType | undefined;
  dispatchReload: () => void;
}
const UpdateClass = (props: Props) => {
  const [classeDesignation, setclasseDesignation] = useState(
    props.data?.classe_designation
  );
  const [classeCode, setclasseCode] = useState(props.data?.code);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const updateAddClasse = async () => {
    if (!classeDesignation?.toString().length) {
      setState({
        ...state,
        errorMessage: "Veuiller complétez la désignation de la classe",
      });
      return setTimeout(() => {
        setState({
          ...state,
          errorMessage: null,
        });
      }, 3000);
    }
    if (!classeCode?.toString().length) {
      setState({
        ...state,
        errorMessage: "Veuiller complétez le code de la classe",
      });
      return setTimeout(() => {
        setState({
          ...state,
          errorMessage: null,
        });
      }, 3000);
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      let data = { designation: classeDesignation, code: classeCode };
      const response = await API_CONFIG.CLASSE.update(
        props.data?.classe_id,
        data,
        token
      );
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succes", { duration: 3000 });
        setclasseCode("");
        setclasseDesignation("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };
  return (
    <div className="UpdateClass">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Modification</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}
          <div className="item">
            <label>Classe</label>
            <input
              placeholder="Ex: 4è Scientifique"
              type="text"
              onChange={(e) => setclasseDesignation(e.target.value)}
              value={classeDesignation}
            />
          </div>
          <div className="item">
            <label>Code</label>
            <input
              placeholder="Ex: 4 SC/A"
              type="text"
              onChange={(e) => setclasseCode(e.target.value)}
              value={classeCode}
            />
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>

          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={updateAddClasse}>Mettre à jour</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateClass;
